/* ===== ux-1004 ux02: "Add to cart and check out" (PDP payment tabs, Pay in full panel) =====
   New asset: assets/bz-ux02-buy-now.js. Loaded from layout/theme.liquid right after blazin.js (defer).
   Markup (templates/product.liquid, ux02 FIND/REPLACE): a submit button that belongs to #add-to-cart-form
   through form="add-to-cart-form", formaction="/cart/add?return_to=%2Fcheckout", data-bz-buy-now.
   With this file: adds the selected variant + quantity via /cart/add.js, then goes to /checkout.
   Without this file (or if it fails): the button submits #add-to-cart-form, so blazin.js does the normal
   Add to Cart (drawer opens). With no JS at all: the native POST to /cart/add?return_to=/checkout.
   Never active on Teton / Blackwood (call-to-plan products; the template does not render the button there either). */
(function () {
  'use strict';
  if (!window.fetch || !document.addEventListener) return;

  function isPlanBuild() {
    var p = location.pathname.toLowerCase();
    return p.indexOf('teton') !== -1 || p.indexOf('blackwood') !== -1 || !!document.querySelector('.bz-plan-build-btn');
  }

  /* Teton / Blackwood: remove the button if an old template copy ever renders it */
  if (isPlanBuild()) {
    document.querySelectorAll('[data-bz-buy-now]').forEach(function (b) {
      var p = b.closest('p');
      (p || b).remove();
    });
    return;
  }

  function variantInfo(form) {
    var idEl = form.querySelector('[name="id"]');
    var id = idEl ? parseInt(idEl.value, 10) : 0;
    var available = true;
    var dataEl = document.getElementById('variant-data');
    if (dataEl && id) {
      try {
        var list = JSON.parse(dataEl.textContent);
        for (var i = 0; i < list.length; i++) {
          if (String(list[i].id) === String(id)) { available = list[i].available !== false; break; }
        }
      } catch (e) { /* keep available = true; Shopify still validates */ }
    }
    var qtyEl = form.querySelector('[name="quantity"]');
    var qty = Math.max(1, parseInt(qtyEl && qtyEl.value, 10) || 1);
    return { id: id, qty: qty, available: available };
  }

  function say(btn, msg) {
    var holder = btn.parentNode;
    var el = holder.querySelector('.bz-buy-now-status');
    if (!el) {
      el = document.createElement('span');
      el.className = 'bz-buy-now-status';
      el.setAttribute('role', 'status');
      el.setAttribute('aria-live', 'polite');
      holder.appendChild(el);
    }
    el.textContent = msg || '';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-bz-buy-now]') : null;
    if (!btn) return;
    var form = document.getElementById(btn.getAttribute('form') || 'add-to-cart-form');
    if (!form) return; /* let the browser do the native submit */
    e.preventDefault();
    e.stopPropagation();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var info = variantInfo(form);
    if (!info.id) { say(btn, 'Please choose your options first.'); return; }
    if (!info.available) { say(btn, 'This option is sold out. Please choose another option.'); return; }

    var label = btn.textContent;
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;
    btn.textContent = 'Adding to cart…';
    say(btn, '');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: info.id, quantity: info.qty }] })
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok) {
          btn.textContent = 'Going to checkout…';
          window.location.href = '/checkout';
          return;
        }
        throw new Error((res.j && (res.j.description || res.j.message)) || '');
      })
      .catch(function (err) {
        btn.removeAttribute('aria-busy');
        btn.disabled = false;
        btn.textContent = label;
        say(btn, (err && err.message) || 'Could not add this to your cart. Please try Add to Cart above.');
      });
  }, true);
})();
/* ===== end ux-1004 ux02 ===== */